import { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import CustomReCAPTCHA from '../CustomCaptcha';
import { DateObject } from "react-multi-date-picker"
import { TransactionService } from '../../services/TransactionService';
import { ITransaction, ITransactionWebModelRequest } from "../../requests/ITransactionWebModelRequest";
import { TFunction, withTranslation } from 'react-i18next';
import "./TransactionReport.scss"
import { allAcquirersFilters, allPaymentModesArg, allPaymentModesUru } from "../../models/TransactionReportConstants"
import { Option } from "../../models/Option"
import { WebCache } from "../../services/WebCache";
import { IIssuer } from "../../models/IIssuer";
import TerminalLocation from "../TerminalLocationNew";
import ErrorsView from '../ErrorsView';
import { UtilService } from "../../services/UtilService";
import { toast } from 'react-toastify';
import TextField from '../controls/fields/textFieldNew';
import NumericField from '../controls/fields/numericFieldNew';
import SelectField from '../controls/fields/selectFieldNew';
import DateField from '../controls/fields/dateFieldNew';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import Page from '../containers/pageNew'
import FormFilter, { FilterBlock } from '../containers/form-filterNew';
import { DateHelper } from '../../helpers/DateHelperNew';
import NavigationTabLinksForTransactions from './NavigationTabLinksForTransactions';
import { Modal } from 'react-bootstrap';
import { TransactionColumns } from './TransactionsColumnsNew';
import { useMessages } from "../MessagesContext";
import { SmartTable } from '../table/SmartTable';
import SideModal from '../containers/side-modal';
import DetailTransaction from './DetailTransaction';
import { ReactComponent as IconHistorySVG } from 'itd-common/assets/icons/icon-history.svg';
import CouponIframe from '../coupons/couponIframe';
import Button from '../controls/buttons/buttonNew';
import TotalTransactions from '../charges/TotalTransactions';
import FilterFiscalDocumentAndCommerce, { MultiSelectRef } from '../FilterFiscalDocumentAndCommerceNew';
import MultiSelectField from '../controls/fields/multiSelectFieldNew';

interface IProps {
    t: TFunction
}
interface IFilters {
    dateRange: Array<DateObject>,
    operationTypeFilter: string,
    initQuestionFilter: string,
    groupFilter: string,
    ticketFilter: string,
    batchFilter: string,
    transactionStateFilter: string,
    terminalFilter: string[],
    authorizationCodeFilter: string,
    authTerminalFilter: string,
    amountFilter: string,
    amountToCustomerFilter: string,
    merchantFilter: string[],
    transactionIdFilter: string
    cardNumberIdFilter: string,
    muIdFilter: string,
    paymentModeFilter: string,
    acquirerFilter: string,
    issuerFilter: string,
    departmentFilter: string,
    locationFilter: string,
    branchFilter: string,
    taxPayerFilter: string[],
    responseCodeSelected: string | null,
    currencySelected: string | null
}

const pageSize = 20;
let [fromDate, toDate] = DateHelper.buildDateRange();
const dateRange = [fromDate, toDate];
const emptyClearStates = { dateRange: dateRange, operationTypeFilter: "", initQuestionFilter: "", groupFilter: "", ticketFilter: "", batchFilter: "", transactionStateFilter: "", authorizationCodeFilter: "", amountFilter: "",  merchantFilter: [], transactionIdFilter: "", cardNumberIdFilter: "", muIdFilter: "", terminalFilter: [], authTerminalFilter: "", amountToCustomerFilter: "", paymentModeFilter: "", acquirerFilter: "", issuerFilter: "", departmentFilter: "", locationFilter: "", branchFilter: "", taxPayerFilter: [], responseCodeSelected: "", currencySelected: "" };
const pageQuantity = 3
const maxDayRange: number = 15;
const pageUrl: string = window.location.href;
const T_PREFIX: string = 'pages.reportTransactions.';
const DEFAULT_COLUMNS: string[] = WebCache.isUserARG() ? ["authDateTime", "terminal", "transactionType", "inputMode", "issuer", "walletProductId", "state", "totalAmountForReport"] : ["authDateTime", "terminal", "transactionType", "inputMode", "issuer", "acquirer", "state", "totalAmountForReport"];

const TransactionReport: React.FC<IProps> = ({ t }: IProps) => {
    const allTransactionStatesFilter = localStorage.getItem("_transactionStatesCode") ? JSON.parse(localStorage.getItem("_transactionStatesCode") as string) : [];
    const allResponseCodes = localStorage.getItem("_transactionResponseCode") ? JSON.parse(localStorage.getItem("_transactionResponseCode") as string) : [];
    const allOperationTypesFilters = localStorage.getItem("_transactionTypesCode") ? JSON.parse(localStorage.getItem("_transactionTypesCode") as string) : [];
    const buildPaymentModesSelectOptions = (): Array<Option> => {
        let respondCodes: Array<Option> = [
            { value: "", label: t("all"), key: "all" } as Option
        ];
        const allPaymentModes = WebCache.isUserARG() ? allPaymentModesArg : allPaymentModesUru;
        const responseCodes: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromEnum(allPaymentModes, 'channel-') as Array<HTMLOptionElement>;
        respondCodes.push(...responseCodes);
        return respondCodes;
    }
    const buildTerminalFilterOptions = (): Array<Option> => {
        const isArg = WebCache.getCurrentUser()?.countryId === 1;
        const terminalNumbers = new Set<string>();
        WebCache.getAllTerminals().forEach(terminal => {
            const number = isArg ? terminal.terminalNumber.replace("B24_", "") : terminal.terminalNumber;
            if (number && number !== "0000")
                terminalNumbers.add(number);
        });
        return Array.from(terminalNumbers).sort().map(number => ({ value: number, label: number, key: number } as Option));
    }
    const [filters, setFilters] = useState<IFilters>(emptyClearStates);
    const [lastHistory, setLastHistory] = useState<string>("");
    const [shouldFetch, setShouldFetch] = useState(false);
    const [mainPage, setMainPage] = useState<number>(0);
    const [showTransactionDetail, setShowTransactionDetail] = useState(false);
    const [showCouponModal, setShowCouponModal] = useState(false);
    const [ticket, setTicket] = useState<string>("");
    const [transactionDetail, setTransactionDetail] = useState<ITransaction>({} as ITransaction);
    const [transactions, setTransactions] = useState<ITransaction[]>([]);
    const [currentIssuers, setCurrentIssuers] = useState<IIssuer[]>(WebCache.getAllIssuers());
    const [currencies, setCurrencies] = useState<Option[]>(UtilService.getCurrencyOptions());
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(sessionStorage.getItem('captchaVerified') === "true");
    const [errors, setErrors] = useState<string[]>([]);
    const [responseCodes, setResponseCodes] = useState<Option[]>(new OptionMapperHelper(t).buildTransactionSelectOptions(allResponseCodes, true))
    const [paymentModes, setPaymentModes] = useState<Option[]>(buildPaymentModesSelectOptions())
    const [terminalOptions] = useState<Option[]>(buildTerminalFilterOptions())
    const [rowDetail, setRowDetail] = useState<{ title: string; total: string; data: Array<{ prop: string; value: string }> } | null>(null)
    const messages = useMessages();
    const terminalChildInstance = useRef<any>(null);
    const merchantFilterRef = useRef<MultiSelectRef>(null);
    const dateFieldRef = useRef<any>(null);
    const [showModalCaptcha, setShowModalCaptcha] = useState(false);

    // vuelve la hora del rango al default de día completo (00:00:00 a 23:59:59), conservando el día/mes/año elegido
    const resetDateRangeTime = (range: Array<DateObject>): Array<DateObject> => {
        const [from, to] = range;
        return [
            Object.assign(new DateObject(from), { hour: 0, minute: 0, second: 0 }),
            Object.assign(new DateObject(to), { hour: 23, minute: 59, second: 59 })
        ];
    }

    const getTransactionRequest = (all: boolean) => {
        const [fromDate, toDate] = filters.dateRange as Array<DateObject>;
        let from_year: number;
        let from_month: number;
        let from_day: number;
        let to_year: number;
        let to_month: number;
        let to_day: number;
        from_year = fromDate.year;
        from_month = fromDate.month.number;
        from_day = fromDate.day;
        to_year = toDate.year;
        to_month = toDate.month.number;
        to_day = toDate.day;

        const getIdOfFilter = (value: string) => {
            return value === "" ? value : value.split("-")[1];
        };
        const tranWebModel: ITransactionWebModelRequest = {
            From: new Date(from_year, from_month - 1,
                from_day,
                fromDate.hour - 3,
                fromDate.minute,
                fromDate.second ?? 0).toJSON(),
            To: new Date(to_year,
                to_month - 1,
                to_day,
                toDate.hour - 3,
                toDate.minute,
                toDate.second ?? 59).toJSON(),
            Terminals: (filters.terminalFilter == null || filters.terminalFilter.length == 0) ? [] : filters.terminalFilter.filter(x => x.length > 0).map(terminal => WebCache.getCurrentUser()?.countryId == 1 ? "B24_" + terminal : terminal),
            TransactionState: (filters.transactionStateFilter == null || filters.transactionStateFilter == "") ? [] : filters.transactionStateFilter.split("-").map(Number),
            TerminalGroup: (filters.groupFilter == null || filters.groupFilter == "") ? "" : filters.groupFilter,
            InitQuestion: (filters.initQuestionFilter == null || filters.initQuestionFilter == "") ? "" : filters.initQuestionFilter,
            OperationType: (filters.operationTypeFilter == null) ? "" : (getIdOfFilter(filters.operationTypeFilter)),
            AuthTerminal: (filters.authTerminalFilter == null || filters.authTerminalFilter == "") ? "" : filters.authTerminalFilter,
            Amount: (filters.amountFilter == null || filters.amountFilter == "") ? "" : normalizeAmountSearch(filters.amountFilter),
            AmountToCustomer: (filters.amountToCustomerFilter == null || filters.amountToCustomerFilter == "") ? "" : filters.amountToCustomerFilter,
            MerchantCodes: filters.merchantFilter.includes("all") ? [] : filters.merchantFilter.filter(x => x.length > 0),
            AuthorizationCode: (filters.authorizationCodeFilter == null || filters.authorizationCodeFilter == "") ? "" : filters.authorizationCodeFilter,
            Issuer: (filters.issuerFilter == null || filters.issuerFilter == "0000") ? "" : filters.issuerFilter,
            Department: (filters.departmentFilter == null || filters.departmentFilter == "0000") ? "" : filters.departmentFilter,
            Location: (filters.locationFilter == null || filters.locationFilter == "0000") ? "" : filters.locationFilter,
            PayerTaxIds: filters.taxPayerFilter.includes("all") ? [] : filters.taxPayerFilter.filter(x => x.length > 0),
            Branch: (filters.branchFilter == null || filters.branchFilter == "0000") ? "" : filters.branchFilter,
            Acquirer: (filters.acquirerFilter == null || filters.acquirerFilter == "0000") ? "" : filters.acquirerFilter,
            TransactionId: (filters.transactionIdFilter == null || filters.transactionIdFilter == "") ? "" : filters.transactionIdFilter,
            CardNumber: (filters.cardNumberIdFilter == null || filters.cardNumberIdFilter == "") ? "" : filters.cardNumberIdFilter,
            MuId: (filters.muIdFilter == null || filters.muIdFilter == "") ? "" : filters.muIdFilter,
            TicketNumber: (filters.ticketFilter == null || filters.ticketFilter == "") ? "" : filters.ticketFilter,
            BatchNumber: (filters.batchFilter == null || filters.batchFilter == "") ? "" : filters.batchFilter,
            PaymentMode: (filters.paymentModeFilter == null || filters.paymentModeFilter == "") ? "" : filters.paymentModeFilter,
            Currency: (filters.currencySelected == null || filters.currencySelected == "") ? "" : filters.currencySelected,
            ResponseCode: (filters.responseCodeSelected == null || filters.responseCodeSelected == "") ? "" : (getIdOfFilter(filters.responseCodeSelected)),
            Skip: all ? 0 : (mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1)
        };
        return tranWebModel;
    }

    const getTransactions = () => {
        TransactionService.getAll(getTransactionRequest(false)).then((response: AxiosResponse<ITransaction[]>) => {
            if (response == null || response.data == null || response.data.length == 0) {
                setTransactions([]);
                setErrors([])
            }
            setTransactions(response.data)
            setErrors([])
        }).catch(error => {
            setErrors(error.response.data)
            console.log('error:', error);
        }
        );
    }

    const getTransactionsToExcel = async (): Promise<void> => {
        if (isCaptchaVerified || WebCache.isPosnetAppUser()) {
            setShowModalCaptcha(false);
            if (WebCache.isPosnetAppUser()) {
                messages.showPosnetNotificationMessage();
            } else {
            messages.showDownloadMessage();
            }
            TransactionService.getAllToExcel(getTransactionRequest(true))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    setErrors(error.response.data)
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    const getFromBuscar = () => {
        if (filters.dateRange.length < 2) {
            toast.error("El filtro periodo es obligatorio, seleccione un rango");
            return;
        }
                 let dateFrom = DateHelper.dateObjectToDate(filters.dateRange[0]);
                let dateTo = DateHelper.dateObjectToDate(filters.dateRange[1]);
                let diffDays = Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
                if (diffDays > maxDayRange) {
                    toast.error(`La busqueda no puede superar los ${maxDayRange} días`);
                    return;
                } 
        setMainPage(0);
        getTransactions();
        let date = DateHelper.buildLastHistoryDate(filters.dateRange[0] as DateObject);
        setLastHistory(date);
        // la búsqueda ya se disparó con la hora elegida; se resetea para que no persista en la próxima búsqueda
        setFilters({ ...filters, dateRange: resetDateRangeTime(filters.dateRange as Array<DateObject>) });
    }

    const clearFilters = () => {
        setFilters(emptyClearStates);
        terminalChildInstance.current?.clearFilters();
        merchantFilterRef.current?.clearFilters();
    }

    const openRangeFilter = () => {
        dateFieldRef.current?.open();
    }

    //obtiene valores predeterminados cuando se hace clearFilters
    useEffect(() => {
        if (shouldFetch) {
            getFromBuscar();
            setShouldFetch(false);
        }
    }, [filters, shouldFetch]);

    const getTicket = async (tranId: string, transactionType: string) => {
        try {
            const response: AxiosResponse<string> = await TransactionService.getTicket(tranId, transactionType);
            setTicket(response.data);
        } catch (error) {
            console.error("Error obteniendo el ticket:", error);
        }
    };
    const showTicket = async (tranId: string, transactionType: string) => {
        await getTicket(tranId, transactionType);
        setShowCouponModal(true);
    };

    const showMoreDetails = (transaction: ITransaction) => {
        setTransactionDetail(transaction);
        setShowTransactionDetail(true);
    }

    const handleShowCoupon = () => {
        getTicket(transactionDetail.id, transactionDetail.transactionType);
        setShowCouponModal(true);
    }

    const handleAcquirerFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        let acquirerId = event.target.value;
        setFilters({
            ...filters,
            acquirerFilter: acquirerId,
            issuerFilter: "0000"
        })
        setCurrentIssuers(WebCache.getAllIssuers())
    }

    const transactionColumns = TransactionColumns({
        t,
        showTicket,
        showMoreDetails,
        showCouponColumn: true,
        setRowDetail
    });

    const buildIssuerSelectOptions = () => {
        let options: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromAnArrayWithDifferentInterface(currentIssuers, 'id', 'issuerName') as Array<HTMLOptionElement>;
        const todosIndex = options.findIndex(option => option.value === '0000');

        if (todosIndex !== -1) {
            const todosOption = options.splice(todosIndex, 1)[0];
            options = [todosOption, ...options];
        }
        options.sort((a, b) => {
            if (a.label === 'Todos') return -1;
            if (b.label === 'Todos') return 1;
            return a.label.localeCompare(b.label);
        });
        return options;
    }

    const normalizeAmountSearch = (value: string): string =>
    value.replace(/\./g, '').replace(',', '.');

    return (
        <Page>
            <>
            <div className={WebCache.isPosnetAppUser() ? 'isPosnetAppUser' : ''}>
                <TotalTransactions rowDetail={rowDetail} link={null}></TotalTransactions>
                <div className="movements">
                    <div className="row">
                        <div className='col-md-9 p-0'>
                            <div className="col-md-12 box-title">
                                {!WebCache.isPosnetAppUser() && <h2>{t(`${T_PREFIX}title`)}</h2>}
                            </div>
                            <div className="col-md-12">
                                <p className="description text-start">{t(`${T_PREFIX}description`)}</p>
                            </div>
                        </div>
                        {
                            lastHistory !== "" &&
                            <div className="col-md-3">
                                <p className="text-end fs-12">{t(`${T_PREFIX}lastUpdate`)}</p>
                                <div className="d-flex justify-content-end align-items-center mb-2" ><p className="m-0 me-2 fw-bolder fs-12">{lastHistory}</p> <span className="icon-history"><IconHistorySVG /></span></div>
                            </div>
                        }
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-lg-9 mt-2">
                                {!WebCache.isPosnetAppUser() && <NavigationTabLinksForTransactions></NavigationTabLinksForTransactions>}
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <ErrorsView errors={errors} />
                        </div>
                    </div>
                    <div className="row">
                        <FormFilter
                            onSubmit={() => getFromBuscar()}
                            model={[filters, setFilters]}
                            clear={() => clearFilters()}
                            hidden={UtilService.isMobilePlatform() ? true : false}
                            page={pageUrl}
                            emptyClearStates={emptyClearStates}
                        >
                            <>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4 pt-2">
                                    <DateField attr="dateRange" label="period" range required={true} ref={dateFieldRef}></DateField>
                                </FilterBlock>
                                    <FilterFiscalDocumentAndCommerce
                                        merchantDocumentConfig={{
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-2",
                                            slot: 'primary'
                                        }}
                                        fiscalDocumentConfig={{
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-2",
                                            slot: 'primary'
                                        }}
                                        changeFilter={(fiscalDocument, merchantNumber) => {
                                            setFilters((currentFilters) => ({
                                                ...currentFilters,
                                                taxPayerFilter: fiscalDocument,
                                                merchantFilter: merchantNumber
                                            }));
                                        }}
                                        includeAllFiscalDocument={true}
                                        includeWholesaler={true}
                                        ref={merchantFilterRef}
                                    />
                                <TerminalLocation
                                    onReady={(inst) => { terminalChildInstance.current = inst; }}
                                    changeFilter={(taxPayerFilter, branchFilter, departmentFilter, locationFilter, departmentName, locationName, branchName, clientDocument) => {
                                        setFilters({
                                            ...filters,
                                            taxPayerFilter: taxPayerFilter,
                                            branchFilter: branchFilter,
                                            departmentFilter: departmentFilter,
                                            locationFilter: locationFilter,
                                        });
                                    }}
                                    filter={{
                                        taxPayerFilter: {
                                            value: filters.taxPayerFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-2",
                                            slot: 'primary'
                                        },
                                        branchFilter: {
                                            value: filters.branchFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                        departmentFilter: {
                                            value: filters.departmentFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                        locationFilter: {
                                            value: filters.locationFilter,
                                            advancedClass: "col-md-12 my-4",
                                            primaryClass: "col-md-3",
                                            slot: 'advanced'
                                        },
                                    }}
                                />
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="operationTypeFilter"
                                        label={t(`${T_PREFIX}transactionType`)}
                                        options={new OptionMapperHelper(t).buildTransactionSelectOptions(
                                            allOperationTypesFilters,
                                            false
                                        )}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="paymentModeFilter"
                                        label={t(`${T_PREFIX}paymentMode`)}
                                        options={paymentModes}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                        <SelectField
                                            attr="acquirerFilter"
                                            label={t(`${T_PREFIX}acquirer`)}
                                            options={new OptionMapperHelper(t).buildSelectOptionsFromEnum(
                                                allAcquirersFilters,
                                                'acquirer-'
                                            )}
                                            onChange={(event) => handleAcquirerFilterChange(event)}
                                        />
                                    </FilterBlock>
                                )}
                                <FilterBlock {...(WebCache.isUserARG() ? { slot: 'primary' } : {})} primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="issuerFilter"
                                        label={t(`${T_PREFIX}issuer`)}
                                        options={buildIssuerSelectOptions()}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="transactionStateFilter"
                                        label={t(`${T_PREFIX}state`)}
                                        options={new OptionMapperHelper(t).buildTransactionSelectOptions(
                                            allTransactionStatesFilter,
                                            false,
                                            true
                                        )}
                                />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="amountFilter"
                                        label={t(`${T_PREFIX}amount`)}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="authorizationCodeFilter"
                                        label={t(`${T_PREFIX}authorizationCode`)}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="cardNumberIdFilter"
                                        label={t(`${T_PREFIX}cardNumber`)}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="batchFilter"
                                        label={t(`${T_PREFIX}batch`)}
                                    />
                                </FilterBlock>
                                <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="ticketFilter"
                                        label={t(`${T_PREFIX}ticket`)}
                                    />
                                </FilterBlock>
                                {WebCache.getCurrentUser()?.countryId === 1 && (
                                    <FilterBlock slot='primary' primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                        <TextField
                                            attr="muIdFilter"
                                            label={t(`${T_PREFIX}muId`)}
                                        />
                                    </FilterBlock>
                                )}
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <MultiSelectField
                                        attr="terminalFilter"
                                        label={t(`${T_PREFIX}terminal`)}
                                        options={terminalOptions}
                                        selectedOptions={filters.terminalFilter}
                                        setSelectedOptions={(selected: string[]) => setFilters({ ...filters, terminalFilter: selected })}
                                        multiSelect={true}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <TextField
                                            attr="authTerminalFilter"
                                            label={t(`${T_PREFIX}authTerminal`)}
                                        />
                                    </FilterBlock>
                                )}
                                {WebCache.isUserUYU() && (
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <NumericField
                                            attr="amountToCustomerFilter"
                                            label={t(`${T_PREFIX}amountToCustomer`)}
                                        />
                                    </FilterBlock>
                                )}
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <TextField
                                        attr="transactionIdFilter"
                                        label={t(`${T_PREFIX}id`)}
                                    />
                                </FilterBlock>
                                {WebCache.isUserUYU() && (
                                    <>
                                        <FilterBlock advancedClass="col-md-12 my-4">
                                            <TextField
                                                attr="initQuestionFilter"
                                                label={t(`${T_PREFIX}initQuestion`)}
                                            />
                                        </FilterBlock>
                                        <FilterBlock advancedClass="col-md-12 my-4">
                                            <TextField
                                                attr="groupFilter"
                                                label={t(`${T_PREFIX}terminalGroup`)}
                                            />
                                        </FilterBlock>
                                    </>
                                )
                                }
                                {
                                    currencies.length > 1 &&
                                    <FilterBlock advancedClass="col-md-12 my-4">
                                        <SelectField
                                            attr="currencySelected"
                                            label={t(`${T_PREFIX}currency`)}
                                            options={currencies}
                                        />
                                    </FilterBlock>
                                }
                                <FilterBlock advancedClass="col-md-12 my-4">
                                    <SelectField
                                        attr="responseCodeSelected"
                                        label={t(`${T_PREFIX}responseCode`)}
                                        options={responseCodes}
                                    />
                                </FilterBlock>
                            </>
                        </FormFilter>
                    </div>
                    <div className="row">
                        <SmartTable
                            data={transactions}
                            config={{
                                pageSize: pageSize,
                                blockSize: (pageSize * pageQuantity),
                                mode: "grid",
                                paginator: {
                                    quantity: pageQuantity,
                                    mainPage: mainPage,
                                    modifyMainPage: (value: number) => {
                                        setMainPage(mainPage + value);
                                        getTransactions();
                                    },
                                    pageRequest: {
                                        Skip: 0,
                                        Take: 0
                                    }
                                },
                                storageKey: 'smart-table:transactions',
                                defaultColumns: DEFAULT_COLUMNS,
                                debugMode: true,
                            }}
                            onDownload={() => setShowModalCaptcha(true)}
                            columnDefinitions={transactionColumns}
                            clearFilters={clearFilters}
                            openRangeFilter={openRangeFilter}
                            onFetchMore={getTransactions}
                        />
                    </div>
                    <>
                        <SideModal title={t(`${T_PREFIX}detailTransactionTitle`)} show={showTransactionDetail} onClose={() => setShowTransactionDetail(false)}>
                            <DetailTransaction transaction={transactionDetail} showCoupon={handleShowCoupon} t={t} isUserUYU={WebCache.isUserUYU()} />
                        </SideModal>
                        <SideModal title={t(`${T_PREFIX}coupon`)} backButton={true} width={"50vw"} show={showCouponModal} onClose={() => setShowCouponModal(false)}>
                            <CouponIframe couponHtml={ticket} />
                        </SideModal>
                        {showModalCaptcha && (
                            <Modal show centered backdrop="static" onHide={() => {
                                setShowModalCaptcha(false);
                                setIsCaptchaVerified(false);
                            }}
                            >
                                <Modal.Body className='captcha-modal-body'>
                                    <h5 className='text-center mb-2'>
                                        Estás por descargar los resultados de búsqueda
                                    </h5>
                                    <p className='text-center mb-3'>
                                        Por seguridad, necesitamos que completes el reCAPTCHA para continuar.
                                    </p>
                                    <div className='d-flex justify-content-center mb-3'>
                                        <div className='captcha-container'>
                                            <CustomReCAPTCHA useCache={true} onVerify={(v: boolean) => setIsCaptchaVerified(v)} />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <div className='captcha-actions'>
                                            <Button color='white' noMargin label="Cancelar" onClick={() => {
                                                setShowModalCaptcha(false);
                                                setIsCaptchaVerified(false);
                                            }}
                                            ></Button>
                                            <Button color='primary' noMargin label="Continuar" disabled={!isCaptchaVerified} onClick={getTransactionsToExcel}
                                            ></Button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        )}
                    </>
                </div>
                </div>
            </>
        </Page>
    );
}
export default withTranslation()(TransactionReport);
